import React, { useState, useEffect } from 'react';
import { Typography, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { queryBooksAPI } from '../../../Api/index.ts';

export default function ListingCard({ listing }) {
  const navigate = useNavigate();
  const [bookCover, setBookCover] = useState('https://via.placeholder.com/116x146');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBookInfo = async () => {
      if (!listing.title && !listing.isbn) {
        setLoading(false);
        return;
      }

      try {
        // Prioritize ISBN search if available
        let query = listing.isbn 
          ? `isbn:${listing.isbn}`
          : `intitle:${listing.title}${listing.author ? ` inauthor:${listing.author}` : ''}`;

        const response = await queryBooksAPI(query);
        const data = await response.json();

        if (!data.items?.length && listing.title) {
          // Fallback to a broader search if ISBN search fails or isn't available
          query = `${listing.title} ${listing.author || ''}`.trim();
          const fallbackResponse = await queryBooksAPI(query);
          const fallbackData = await fallbackResponse.json();
          if (fallbackData.items?.length) {
            data.items = fallbackData.items;
          }
        }

        // If we found a book cover, update it
        if (data.items?.[0]?.volumeInfo?.imageLinks?.thumbnail) {
          const imageUrl = data.items[0].volumeInfo.imageLinks.thumbnail
            .replace('http://', 'https://')
            // Get a larger image by modifying the zoom parameter
            .replace('zoom=1', 'zoom=0');
          setBookCover(imageUrl);
        } else {
          // If no cover found, keep the placeholder
          setBookCover('https://via.placeholder.com/116x146');
        }
      } catch (error) {
        console.error('Error fetching book cover:', error);
        // On error, keep the placeholder
        setBookCover('https://via.placeholder.com/116x146');
      } finally {
        setLoading(false);
      }
    };

    fetchBookInfo();
  }, [listing.title, listing.author, listing.isbn]);

  const handleCardClick = () => {
    navigate(`/listing/${listing.id}`);
  };

  return (
    <div className="card-wrapper" onClick={handleCardClick} style={{ cursor: 'pointer' }}>
      <div className="card">
        {loading ? (
          <div className="book-image-loading">
            <CircularProgress size={24} />
          </div>
        ) : (
          <img className="book-image" src={bookCover} alt="Book Cover" />
        )}
        <div className="info">
          <h4 className="title">
            {listing.title ? `${listing.title} (${listing.year || 'Year Unknown'})` : 'No Title Available'}
          </h4>
          <p className="author">by {listing.author || 'Author Unknown'}</p>
          <div className="typography-wrapper">
            <Typography variant="body2">{listing.bookType || 'Book Type not available'}</Typography>
            <Typography variant="body2">Condition: {listing.condition || 'Condition not available'}</Typography>
          </div>
          <div className="seller-price-wrapper">
            <p className="seller">Seller from {listing.seller || 'Unknown'}</p>
            <p className="price">
              {listing.price != null ? `$${listing.price.toFixed(2)}` : 'Price not available'}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}